import React from "react";
import { Link } from "react-router-dom";

import {
	PERFORMYARD_LOGO_DARK_URL,
	PERFORMYARD_LOGO_LIGHT_URL,
	SIDE_NAV_FOREGROUND_LIGHT,
} from "@performyard/utils-isomorphic";

import type { NavigationConfig } from "../../api/services/defs/navigation";

const resolveLogoUrl = (config: NavigationConfig): { url: string; alt: string } => {
	if (config.logoUrl) return { url: config.logoUrl, alt: "Company logo" };
	// Default to light foreground to match <SideNavShell>'s SIDE_NAV_PRIMARY_BLUE_THEME fallback.
	const foreground = config.sideNavTheme?.foregroundColor ?? SIDE_NAV_FOREGROUND_LIGHT;
	const isLightForeground = foreground === SIDE_NAV_FOREGROUND_LIGHT;
	return {
		url: isLightForeground ? PERFORMYARD_LOGO_LIGHT_URL : PERFORMYARD_LOGO_DARK_URL,
		alt: "PerformYard",
	};
};

type SideNavLogoProps = {
	config: NavigationConfig;
};

export const SideNavLogo = ({ config }: SideNavLogoProps) => {
	const { url, alt } = resolveLogoUrl(config);
	return (
		<Link
			to="/"
			aria-label="Go to dashboard"
			className="flex h-12 w-[286px] max-w-full items-center justify-center focus-visible:ring-2 focus-visible:ring-[color:var(--sidenav-fg,currentColor)] focus-visible:outline-none"
		>
			<img src={url} alt={alt} className="h-8 w-auto max-w-[184px] object-contain" />
		</Link>
	);
};
